 const auxilary = (props) => {
 	return props.children;
 }

 export default auxilary;